import { SearchX as SearchOffIcon } from 'lucide-react';
import React from 'react';

import { Flex } from './components/Flex';
import { MoviesGrid } from './components/Movie/MoviesGrid';
import { MovieSkeleton } from './components/Movie/MovieSkeleton';
import { PeopleGrid } from './components/Movie/PeopleGrid';
import { useMediaQuery } from './hooks/useMediaQuery';

export function MovieList({
  movies,
  people = null,
  loading,
  suspendAnimations = false,
}) {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [showContent, setShowContent] = React.useState(false);

  // Trigger fade-in animation when content changes
  React.useEffect(() => {
    if (suspendAnimations) return;
    setShowContent(false);
    const timer = setTimeout(() => setShowContent(true), 50);
    return () => clearTimeout(timer);
  }, [movies, loading, suspendAnimations]);

  const skeletonItems = React.useMemo(
    () => Array.from({ length: 20 }, (_, i) => i),
    [],
  );

  function SkeletonGrid() {
    return (
      <div
        className={showContent ? 'fade-in' : ''}
        style={{
          width: '100%',
          padding: '12px',
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fill, 300px)`,
          gap: '8px',
          justifyContent: 'center',
          opacity: showContent ? 1 : 0,
        }}
      >
        {skeletonItems.map((i) => (
          <MovieSkeleton key={i} isMobile={isMobile} />
        ))}
      </div>
    );
  }

  // Show skeletons when loading with no data
  if (movies.length === 0) {
    if (loading) {
      return (
        <Flex justify="center" align="center" direction="column">
          <SkeletonGrid />
        </Flex>
      );
    }
    // Show empty state when not loading and no data
    return (
      <Flex justify="center" align="center" direction="column">
        <SearchOffIcon /> No results to show
      </Flex>
    );
  }

  // Show data
  return (
    <div style={{ width: '100%' }}>
      <Flex justify="center" align="center" direction="column">
        <MoviesGrid movies={movies} showContent={showContent} />
        <PeopleGrid people={people} showContent={showContent} />
      </Flex>
    </div>
  );
}
